import { APIForm } from './_api-form.js';
class NewPassword extends APIForm {
  constructor() {
    super();
    this._successRedirectUrl = null;
    this._redirectAfterPopinUrl = null;
    this._confirmationModal = null;
  }
  connectedCallback() {
    super.connectedCallback();
    // Get the success redirect URL from the data-success attribute
    this._successRedirectUrl = this.getAttribute('data-success');
    // Get the redirect URL to use after the modal is closed
    this._redirectAfterPopinUrl = this.getAttribute('data-redirect-after-popin');

    // If we have a modal ID, get the modal element and add a close event listener
    if (this._successHandler === 'modal' && this._successRedirectUrl) {
      // Wait for the DOM to be fully loaded
      setTimeout(() => {
        this._confirmationModal = document.getElementById(this._successRedirectUrl);
        if (this._confirmationModal) {
          this._confirmationModal.addEventListener('modal:closed', this._handleModalClose.bind(this));
        }
      }, 0);
    }
  }
  disconnectedCallback() {
    // Clean up event listeners
    if (this._confirmationModal) {
      this._confirmationModal.removeEventListener('modal:closed', this._handleModalClose.bind(this));
      this._confirmationModal = null;
    }
    super.disconnectedCallback();
  }
  _handleModalClose() {
    // When the modal is closed, redirect if we have a URL to redirect to
    if (this._redirectAfterPopinUrl) {
      window.location.href = this._redirectAfterPopinUrl;
    }
  }
  _getDefaultEndpoint() {
    return "/wp-json/api/v1/ambassador/password-reset-when-authenticated";
  }
}
customElements.define('new-password', NewPassword);